'use strict';

// Translation files
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _deDe = _interopRequireDefault(require("./de-de"));
var _enAu = _interopRequireDefault(require("./en-au"));
var _enAe = _interopRequireDefault(require("./en-ae"));
var _enCa = _interopRequireDefault(require("./en-ca"));
var _enDk = _interopRequireDefault(require("./en-dk"));
var _enFi = _interopRequireDefault(require("./en-fi"));
var _enHk = _interopRequireDefault(require("./en-hk"));
var _enIn = _interopRequireDefault(require("./en-in"));
var _enSe = _interopRequireDefault(require("./en-se"));
var _enSg = _interopRequireDefault(require("./en-sg"));
var _enUk = _interopRequireDefault(require("./en-uk"));
var _enUs = _interopRequireDefault(require("./en-us"));
var _enZa = _interopRequireDefault(require("./en-za"));
var _frCa = _interopRequireDefault(require("./fr-ca"));
var _frFr = _interopRequireDefault(require("./fr-fr"));
var _itIt = _interopRequireDefault(require("./it-it"));
var _jaJp = _interopRequireDefault(require("./ja-jp"));
var _koKr = _interopRequireDefault(require("./ko-kr"));
var _nlNl = _interopRequireDefault(require("./nl-nl"));
var _enNo = _interopRequireDefault(require("./en-no"));
var _enBe = _interopRequireDefault(require("./en-be"));
var _ptBr = _interopRequireDefault(require("./pt-br"));
var _spMx = _interopRequireDefault(require("./sp-mx"));
var _esEs = _interopRequireDefault(require("./es-es"));
var _esAr = _interopRequireDefault(require("./es-ar"));
var _zhHansCn = _interopRequireDefault(require("./zh-hans-cn"));
var _zhTw = _interopRequireDefault(require("./zh-tw"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// ES-CO, ES-AR, ES-PE, ES-Cl
// Are all clones of es-es concur.es
// COM-5363
var index = {
  'de-de': _deDe.default,
  'en-au': _enAu.default,
  'en-ae': _enAe.default,
  'en-ca': _enCa.default,
  'en-dk': _enDk.default,
  'en-fi': _enFi.default,
  'en-hk': _enHk.default,
  'en-in': _enIn.default,
  'en-se': _enSe.default,
  'en-sg': _enSg.default,
  'en-uk': _enUk.default,
  'en-us': _enUs.default,
  'en-za': _enZa.default,
  'en-no': _enNo.default,
  'fr-ca': _frCa.default,
  'fr-fr': _frFr.default,
  'it-it': _itIt.default,
  'ja-jp': _jaJp.default,
  'ko-kr': _koKr.default,
  'nl-nl': _nlNl.default,
  'en-be': _enBe.default,
  'pt-br': _ptBr.default,
  'sp-mx': _spMx.default,
  'es-es': _esEs.default,
  'es-ar': _esAr.default,
  'zh-hans-cn': _zhHansCn.default,
  'zh-tw': _zhTw.default
};

// LATAM Sites are based on EsAr menu
index['es-pe'] = _esAr.default;
index['es-pe']['domain'] = 'https://www.concur.pe';
index['es-cl'] = _esAr.default;
index['es-cl']['domain'] = 'https://www.concur.cl';
index['es-co'] = _esAr.default;
index['es-co']['domain'] = 'https://www.concur.co';
var _default = exports.default = index;